<main class="bg-slate-100 flex flex-col layout-main-container">
    @if(currentMode === 'SELECTION'){
        <header class="flex justify-between items-center p-3 border-gray-100 border-b">
            <h2 class="text-2xl font-semibold text-gray-700 mb-1 mx-1.5">
                <span>
                    {{'text.create_new_workflow' | translate}}
                </span>
            </h2>
            <div>
                <i class="ti ti-x text-2xl w-6 h-6 text-gray-500 hover:bg-gray-100 px-2 py-1.5 rounded-full" (click)="closeModal()"></i>
            </div>
        </header>
    }@else if (currentMode === 'TEMPLATES') {
        <header class="flex justify-between items-center p-3 border-gray-100 border-b">
            <div class="flex items-center ml-2 space-x-3">
                <span class="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100" (click)="currentMode = 'SELECTION'">
                    <i class="ti ti-arrow-left text-3xl"></i>
                </span>
                <brn-select class="inline-block bg-white rounded-md" placeholder="{{'text.select_option' | translate}}" [(ngModel)]="selectedCategory" (ngModelChange)="selectCategory()">
                    <hlm-select-trigger>
                        <hlm-select-value class="text-base" />
                    </hlm-select-trigger>
                    <hlm-select-content class="w-auto min-w-52">
                            <hlm-option value="" class="whitespace-nowrap text-base">{{'text.all_templates' | translate}}</hlm-option>
                            <hlm-option [value]="category?.category_uid" class="text-base" *ngFor="let category of allCategories">{{category?.category_name}}</hlm-option>
                    </hlm-select-content>
                </brn-select>
            </div>

            <div class="flex space-x-2 items-center">
                <form class="field-container">   
                    <label for="default-search" class="mb-2 text-base font-medium text-gray-700 sr-only">{{'text.search' | translate}}</label>
                    <div class="relative bg-white rounded-full">
                        <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                            <svg class="w-3 h-3 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
                            </svg>
                        </div>
                        <input
                            id="default-search"
                            class="block w-80 p-2 leading-5 h-10 pl-8 pr-8 text-base text-gray-700 border border-gray-200 rounded-lg bg-white"
                            [(ngModel)]="keyword"
                            [ngModelOptions]="{standalone: true}"
                            (keyup.enter)="searchKeyword()"
                            placeholder="{{'text.search_templates' | translate}}" 
                            autocomplete="off"
                            required>
                        <i 
                            class="ti ti-x absolute right-2.5 bottom-3 text-base cursor-pointer" 
                            (click)="clearSearch()"
                            *ngIf="keyword"
                            ></i>
    
                    </div>
                </form>
                <i class="ti ti-x w-8 h-8 text-2xl text-gray-500 justify-center hover:bg-gray-100 px-2 flex items-center py-2 rounded-full" (click)="closeModal()"></i>
            </div>
        </header>
    }@else if (currentMode === 'PREVIEW') {
        <header class="flex justify-between items-center p-3 border-gray-100 border-b">
            <div class="flex items-center ml-2 space-x-3">
                <span class="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100">
                    <i class="ti ti-arrow-left text-3xl" (click)="goToTemplates()"></i>
                </span>
                <h2 class="text-2xl font-semibold">{{selectedTemplate?.template_name}}</h2>
            </div>

            <div class="flex space-x-2 items-center">
                <button 
                    (click)="createWorkflowFromTemplate(selectedTemplate?.template_uid)"
                    type="button"
                    class="flex justify-between items-center text-gray-100 bg-blue-700 font-medium rounded-lg text-base px-3 py-2 h-10 btn-primary"
                    >
                    <i class="ti ti-{{button?.icon}} mr-2 text-base"></i>
                    {{'text.label.use_this_template' | translate}}
                </button>
                <i class="ti ti-x w-8 h-8 text-2xl text-gray-500 justify-center hover:bg-gray-100 px-2 flex items-center py-2 rounded-full" (click)="closeModal()"></i>

            </div>
        </header>
    }
    <main class="content-body-container" [ngClass]="{'expanded': currentMode !== 'SELECTION'}">
        @if(currentMode === 'SELECTION'){
            <div class="p-6 flex space-x-4">
                <a class="block w-full p-2 bg-white border border-gray-200 rounded-lg shadow cursor-pointer" (click)="createWorkflow(initialWorkflowData)">
                    <div 
                    class="min-h-[20rem] bg-center bg-no-repeat bg-cover"
                    [ngStyle]="{'background-image': 'url(assets/images/svgs/placeholder_view.svg)'}"
                    >
                        <img [src]="'assets/images/svgs/create_new.svg'" class="w-full" alt="">
                    </div>
                    <div class="p-2">
                        <h5 class="mb-2 mt-2 text-3xl font-bold tracking-tight text-gray-700">{{'text.start_from_scratch' | translate}}</h5>
                        <p class="font-normal text-gray-500">{{'text.create_workflow_from_scratch' | translate}}</p>
                    </div>
                </a>
                <a class="block w-full p-2 bg-white border border-gray-200 rounded-lg shadow cursor-pointer" (click)="getTemplates()">
                    <div 
                    class="min-h-[20rem] bg-center bg-no-repeat bg-cover"
                    [ngStyle]="{'background-image': 'url(assets/images/svgs/placeholder_view.svg)'}"
                    >
                        <img [src]="'assets/images/svgs/template_preview.svg'" class="w-full" alt="">
                    </div>
                    <div class="p-2">
                        <h5 class="mb-2 mt-2 text-3xl font-bold font-semibold tracking-tight text-gray-700">{{'text.choose_from_templates' | translate}}</h5>
                        <p class="font-normal text-gray-500">{{'text.create_workflow_using_templates' | translate}}</p>
                    </div>
                </a>
            </div>
        }@else if (currentMode === 'TEMPLATES') {
            @if(workflowTemplates.length > 0){
                <div class="zuper-scrollbar overflow-auto p-2 templates-main-container">
                    <div class="rounded-xl p-2 mt-2 grid grid-cols-3 gap-4 overflow-y-auto ">            
                        @for(template of workflowTemplates; track $index){
                            <a class="block bg-white border border-gray-100 rounded-lg cursor-pointer template-card shadow-sm" (click)="openTemplate(template)">
                                <div 
                                    class="min-h-[10rem] bg-center bg-no-repeat bg-cover"
                                    [ngStyle]="{'background-image': 'url(assets/images/svgs/placeholder_view.svg)'}"
                                    >
                                    <img [src]="template?.template_icon" class="w-full" alt="">
                                </div> 
                                <div class="p-4">
                                    <h4 class="text-lg text-gray-700 font-semibold">{{template?.template_name}}</h4>
                                    <p class="text-gray-400 mt-2 text-ellipsis overflow-hidden line-clamp-3">{{template?.template_description}}</p>
                                </div>
                            </a>
                        }
                        
                    </div>
                    @if(!showLoader){
                        <div class="text-center mt-2 text-gray-700 cursor-pointer" *ngIf="(totalRecords > workflowTemplates.length)" (click)="loadTemplates()">{{'text.load_more' | translate}}</div>
                    }@else if(showLoader){
                        <lazy-loader />
                    }
                </div>
            }@else if(showLoader && workflowTemplates.length === 0){
                <div class="shimmer-container rounded-xl p-3 bg-slate-50 mt-2 grid grid-cols-3 gap-4 overflow-auto zuper-scrollbar">
                    <app-card-skeleton *ngFor="let shimmer of shimmerArr"></app-card-skeleton>
                </div>
            }@else{
                <div class="no-result-container rounded-xl p-3 bg-slate-50 mt-2 flex justify-center items-center">
                    <div class="flex justify-center flex-col items-center">
                        <img [src]="'assets/images/svgs/no_result.svg'" class="w-48 h-48" alt="" loading="lazy">
                        <h4 class="text-lg text-gray-500 font-semibold mt-2" *ngIf="filter['filter.keyword']">{{'text.no_result_found' | translate}} "{{filter['filter.keyword']}}" <span *ngIf="currentCategory?.category_name">{{'text.in' | translate}} {{currentCategory?.category_name}}</span></h4>
                        <h4 class="text-lg text-gray-500 font-semibold mt-2" *ngIf="!filter['filter.keyword']">{{'text.no_templates_found' | translate}}</h4>
                        <p class="text-base text-gray-400 mt-2" *ngIf="filter['filter.keyword']">{{'text.check_spelling_error' | translate}}</p>
                        <p class="text-base text-gray-400 mt-2" >{{'text.suggestion_for_template' | translate}} <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=zVrY5KOpT0-uUBhlmXUHy5geJDTI74xGg__tHt3QYxpUQTNaSDBQMk1UOEhGUDUwR0RFWlJMN0Q4Qi4u" class="text-sky-500" target="_blank">{{'text.submit' | translate}}</a> {{'text.this_form' | translate}}</p>
                    </div>
                </div>
            }
            
        }@else if(currentMode === 'PREVIEW'){
            <div class="templates-main-container w-full overflow-auto zuper-scrollbar px-2">
                <p class="p-3 text-gray-700 px-6 my-3">{{selectedTemplate?.template_description}}</p>
                <img [src]="selectedTemplate?.template_image" class="w-full" alt="">
            </div>
        }
    </main>
</main>
